import { MilestoneIcon } from 'lucide-react'

import { VisaBulletinInfoCard } from '@/pages/client-portal/ui/cards/visa-bulletin-info-card/visa-bulletin-info-card'
import { VisaBulletinTrendCard } from '@/pages/client-portal/ui/cards/visa-bulletin-trend-card/visa-bulletin-trend-card'
import { ContentSectionHeader } from '@/pages/client-portal/ui/content-section-header/content-section-header'

import { useClientPortalInternalSampleStore } from '@/lib/stores/client-portal-internal-sample-store'
import { cn } from '@/lib/utils'

export const VisaBulletin = () => {
  const { currentCase } = useClientPortalInternalSampleStore()

  // Data
  const visaBulletinData = currentCase?.visaBulletin
  const visaBulletinTrendData = currentCase?.visaBulletinTrend
  const priorityDate = currentCase?.priorityDate

  // Boolean values for branching UI
  const { visaBulletin: showsVisaBulletinInfo, visaBulletinTrend: showsVisaBulletinTrend } =
    currentCase?.portalOptions ?? {}

  return (
    <div className={cn('mt-[30px]')}>
      <ContentSectionHeader icon={<MilestoneIcon size={24} />} title="Visa Bulletin" />

      <div
        className={cn('flex flex-col gap-y-5 lg:grid', 'mt-5', {
          'lg:grid-cols-[400px_auto] lg:gap-5': showsVisaBulletinInfo && showsVisaBulletinTrend,
        })}
      >
        {showsVisaBulletinInfo && (
          <div className={cn('lg:max-w-[400px]')}>
            <VisaBulletinInfoCard visaBulletinData={visaBulletinData} />
          </div>
        )}
        {showsVisaBulletinTrend && (
          <div className={cn('min-w-0')}>
            <VisaBulletinTrendCard visaBulletinTrendData={visaBulletinTrendData} priorityDate={priorityDate} />
          </div>
        )}
      </div>
    </div>
  )
}
